<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Prelims-head">Dedication</h1>
<p class="Prelims-main">To MVP</p>
<p class="Prelims-main">Thank you</p>
<p class="Prelims-main"> For the push</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398433502_EPUB3.vue?58292d42